import { Box, Grid, Typography } from "@mui/material"
import {
    Project36, User36,
    Aicamera48, Camera36,
    Companyoutline48, Timelapsecamera48, Livecamera48
} from "../../components/icons/Icons"

import { ReactComponent as CompanyIcon } from "./icons/company_outline_48x48.svg";
import { ReactComponent as ProjectIcon } from "./icons/project_outline_48x48.svg";
import { ReactComponent as UserIcon } from "./icons/user_outline_48x48.svg";
import { ReactComponent as CameraIcon } from "./icons/camera3_outline_48x48.svg";



const RoundBar = ({ title, count, icon, onClick, isSuperAdmin }) => {
    const small = isSuperAdmin ? "" : "-small"
    return (
        <Box onClick={onClick} className={`light-border rounded-lg shadow status-card${small}`}
            sx={{
                width: 1,
                display: 'flex', alignItems: 'center',
                justifyContent: { xs: 'column', sm: 'space-between' },
                flexDirection: { xs: 'column', sm: isSuperAdmin ? 'row' : 'row-reverse' },
            }}
        >
            <Box className={`rounded-lg bg-light-gray dark-gray counter`}
                sx={{ fontWeight: 600 }}>
                {count}
            </Box>
            <Typography className={`dark-gray text`} width={1} sx={{ fontSize: 16, px: 1, fontWeight: 500, textAlign: { xs: 'center', sm: 'left' } }}>{title}</Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' }, textAlign: 'right', height: 48 }}>{icon}</Box>

        </Box>

    )
}

const StatusCard = ({ datas, onCardClick, isSuperAdmin = false, userType }) => {
    const col = isSuperAdmin ? { xs: 6, sm: 6 } : { xs: 12, sm: 12 }
    const space = !isSuperAdmin ? 2 : 2 //'2.332vmin'
    const height = !isSuperAdmin ? 84 : 114
    const iconSize = !isSuperAdmin ? 24 : 48
    const data = {}
    datas.forEach(element => {
        if (element.name === 'Company') {
            data.company_count = element.count
        } else if (element.name === 'User') {
            data.user_count = element.count
        } else if (element.name === 'Camera') {
            data.camera_count = element.count
        } else if (element.name === 'Project') {
            data.project_count = element.count
        }

    });
    return (<>
        <Grid container spacing={space}>
            {isSuperAdmin && <Grid item size={col}>
                <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Company" count={data.company_count || 0}
                    icon={<CompanyIcon size={iconSize} className="dark-gray" />} onClick={() => onCardClick('company')} />
            </Grid>}

            {userType !== 0 && <>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Project" count={data.project_count || 0}
                        icon={<ProjectIcon size={iconSize} className="dark-gray" />} onClick={() => onCardClick('project')} />
                </Grid>

                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="User" count={data.user_count || 0}
                        icon={<UserIcon size={iconSize} className="dark-gray" />} onClick={() => onCardClick('user')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Camera" count={data.camera_count || 0}
                        icon={<CameraIcon style={{ marginTop: 5 }} size={iconSize} className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
            </>}



            {userType === 0 && <>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Surveillance cameras" count={data.camera_count || 0}
                        icon={<CameraIcon variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Timelapse cameras" count={data.camera_count || 0} icon={<Timelapsecamera48 variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="AI Cameras" count={data.camera_count || 0} icon={<Aicamera48 variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                    {/* {JSON.stringify(data)} */}

                </Grid>
            </>}
        </Grid>
    </>
    )
}

export default StatusCard